import {
  useBlocksConfig,
  useEditorStateSelector,
  useSyncer
} from "@pathwright/blocks-engine"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useState } from "react"
import ContentPublishCard from "./ContentPublishCard"
import ContentPublishPanel from "./ContentPublishPanel"

const ContentPublishAction = ({ needsPublish }: { needsPublish: boolean }) => {
  const { tc } = useTranslate()
  const { saveAudience, cohortCustomization } = useBlocksConfig()
  const {
    blocksContext,
    customizationBusy,
    customizationError,
    setCustomizationsEnabled,
    checkCustomizationResponses
  } = useSyncer()
  const customization = blocksContext?.customization
  const caps = customization?.capabilities
  const syncing = useEditorStateSelector((state) => state.syncing)
  const publishing = useEditorStateSelector((state) => state.publishing)
  const discarding = useEditorStateSelector((state) => state.discarding)
  const discard = useEditorStateSelector(
    (state) => state.handleDiscardDraftContent
  )
  const publish = useEditorStateSelector((state) => state.handlePublishContent)
  const changes = useEditorStateSelector((state) => state.changes)
  const [open, setOpen] = useState(false)
  const busy = !!(syncing || publishing || discarding || customizationBusy)
  const cohortName = cohortCustomization?.cohortName || tc("this Cohort")
  const canPublish = !customization?.enabled || caps?.canPublish
  const canDiscard = !customization?.enabled || caps?.canRevert
  const shared =
    !customization?.enabled &&
    (!!saveAudience?.shared || saveAudience?.cohortCount != null)
  const audience = shared
    ? saveAudience?.cohortCount && saveAudience.cohortCount > 1
      ? tc("All {{count}} cohorts", { count: saveAudience.cohortCount })
      : tc("All cohorts")
    : customization?.enabled
    ? cohortName
    : saveAudience?.name || tc("this Path")
  const canDisable =
    !!cohortCustomization && customization?.enabled && caps?.canDisable

  return (
    <ContentPublishCard
      label={tc("Publish Blocks")}
      icon={shared ? "recur" : "group"}
      needsPublish={needsPublish}
      busy={!!customizationBusy}
      open={open}
      onOpenChange={setOpen}
    >
      <ContentPublishPanel
        open={open}
        changes={changes}
        needsPublish={needsPublish}
        audience={audience}
        shared={shared}
        checkResponses={checkCustomizationResponses}
        busy={busy}
        publishing={!!publishing}
        canPublish={!!canPublish && !customizationError}
        onPublish={publish}
        onDiscard={canDiscard ? discard : undefined}
        onRevert={
          canDisable ? () => setCustomizationsEnabled!(false) : undefined
        }
        onClickBlockChange={(blockID) => {
          document
            .getElementById(`block-${blockID}`)
            ?.scrollIntoView({ behavior: "smooth", block: "center" })
          setOpen(false)
        }}
      />
    </ContentPublishCard>
  )
}

export default ContentPublishAction
